const routes = [
    {
        path: '/contabilidade/contabil/etapa_conta_bancaria/:hash',
        component: () => import('../views/EtapaContaBancaria'),
    },
    {
        path: '/contabilidade/contabil/etapa_conta_descontos/:hash',
        component: () => import('../views/EtapaContaDescontos'),
    },
    {
        path: '/contabilidade/contabil/etapa_conta_juros/:hash',
        component: () => import('../views/EtapaContaJuros'),
    },
    {
        path: '/contabilidade/contabil/etapa_clientes_fornecedores/:hash',
        component: () => import('../views/EtapaClientesFornecedores'),
    },
    {
        path: '/contabilidade/contabil/exportar/:hash',
        component: () => import('../views/Exportar'),
    },
]
export default routes
